var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconBell(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props),
        React.createElement("path", { d: "M4 19V17.5H6.1V9.85C6.1 8.45 6.5125 7.20417 7.3375 6.1125C8.1625 5.02083 9.25 4.33333 10.6 4.05V3.325C10.6 2.94167 10.7375 2.625 11.0125 2.375C11.2875 2.125 11.6167 2 12 2C12.3833 2 12.7125 2.125 12.9875 2.375C13.2625 2.625 13.4 2.94167 13.4 3.325V4.05C14.75 4.33333 15.8417 5.02083 16.675 6.1125C17.5083 7.20417 17.925 8.45 17.925 9.85V17.5H20V19H4ZM12 22C11.4667 22 11 21.8042 10.6 21.4125C10.2 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM7.6 17.5H16.425V9.85C16.425 8.61667 16 7.56667 15.15 6.7C14.3 5.83333 13.2583 5.4 12.025 5.4C10.7917 5.4 9.74583 5.83333 8.8875 6.7C8.02917 7.56667 7.6 8.61667 7.6 9.85V17.5Z", fill: fillColor })));
}
export default memo(withIconDefaults(IconBell));
